module.exports = __webpack_public_path__ + "img/export.7aa52ea6.svg";